package pages.stock

import ics.materialUI.components.classes.ContentFieldMapping

object StockPageFieldMapping {
    val headerSequence: Array<String> = arrayOf(
        "article",
        "owner",
        "category",
        "articleNumber",
        "variantCode",
        "sizeCode",
        "colorDescription",
        "description",
        "neededStock",
        "availableStock",
        "assignedStock",
        "stock"

    )
    object fieldMappings {
        val english: Array<ContentFieldMapping> = arrayOf(
            ContentFieldMapping(
                "article",
                "Article"
            ),
            ContentFieldMapping(
                "owner",
                "Owner"
            ),
            ContentFieldMapping(
                "category",
                "Category"
            ),
            ContentFieldMapping(
                "articleNumber",
                "Arcticle number"
            ),
            ContentFieldMapping(
                "variantCode",
                "Variant code"
            ),
            ContentFieldMapping(
                "sizeCode",
                "Size code"
            ),
            ContentFieldMapping(
                "colorDescription",
                "Color description"
            ),
            ContentFieldMapping(
                "description",
                "Description"
            ),
            ContentFieldMapping(
                "neededStock",
                "Needed"
            ),
            ContentFieldMapping(
                "availableStock",
                "Available"
            ),
            ContentFieldMapping(
                "assignedStock",
                "Assigned"
            ),
            ContentFieldMapping(
                "stock",
                "Stock"
            )
        )
    }
}